import React, { useCallback, useState } from 'react';
import { Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { toast } from 'react-toastify';
import useStyles from './AlterarClienteProcesso.style';
import {
  STATUS_CLIENTE_ATIVO,
  MINIMO_PALAVRAS_JUSTIFICATIVA,
  MAX_LENGTH_NUM_PROCESSO,
  MAX_COUNTER_JUSTIFICATIVA,
  RECALCULAR_VALOR_OPTIONS,
  TITULO_PAGINA,
  SUBTITULO_PAGINA,
  LABEL_NUMERO_PROCESSO,
  LABEL_CODIGO_CLIENTE,
  LABEL_RAZAO_SOCIAL_NOME,
  LABEL_NOVO_CODIGO_CLIENTE,
  LABEL_RECALCULAR_PROCESSO,
  LABEL_JUSTIFICATIVA,
  LABEL_CONSULTAR,
  LABEL_ALTERAR,
  MENSAGEM_ERRO_BUSCA_PROCESSO,
  MENSAGEM_ERRO_BUSCA_CLIENTE_NOVO,
  MENSAGEM_ERRO_VERIFICAR_PAGAMENTO,
  MENSAGEM_BLOQUEIO_PAGAMENTO,
  MENSAGEM_SUCESSO_ALTERACAO,
  MENSAGEM_ERRO_ALTERACAO,
  MENSAGEM_CONFIRMACAO_ALTERACAO,
  MENSAGEM_ERRO_HISTORICO_AUTOMATICO,
} from './alterarClienteProcesso.constants';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm/WrapperSubTitleForm';
import Grid24 from '../../../components/UI/Grid24/Grid24';
import {
  SelectorField, TextareaField, ButtonUI,
} from '../../../components';
import NumberInput from '../../../components/UI/Field/Number/NumberInput';
import InputField from '../../../components/UI/Field/Input/InputField';
import OptionDialogNew from '../../../components/UI/Dialogs/OptionDialog/OptionDialogNew';
import { SearchButton } from '../../../components/SearchButton/SeachButton';
import { getExceptionMessage } from '../../../helpers';
import {
  findClienteByNumProcesso,
  updateClienteDoProcesso,
} from '../../../services/core/manutencao/manutencao.service';
import { findSimpleCliente } from '../../../services/core/cliente/cliente.services';
import { findFichaFinanceiraAnalitica } from '../../../services/core/processos/processosFichaFinanceira';
import { inserirNovoHistorico } from '../../../services/core/processos/processosService';
import { tiposHistoricos } from '../../../types/tiposHistoricoTypes';

function possuiMinimoPalavras(texto, minimo) {
  return texto.trim().split(/\s+/).filter(Boolean).length >= minimo;
}

export default function AlterarClienteProcesso() {
  const style = useStyles();

  const [loading, setLoading] = useState(false);
  const [numProcesso, setNumProcesso] = useState('');
  const [clienteAtual, setClienteAtual] = useState(null);

  const [loadingPagamento, setLoadingPagamento] = useState(false);
  const [bloqueadoPorPagamento, setBloqueadoPorPagamento] = useState(false);
  const [podeAlterar, setPodeAlterar] = useState(false);

  const [codigoNovoCliente, setCodigoNovoCliente] = useState('');
  const [clienteNovo, setClienteNovo] = useState(null);
  const [loadingClienteNovo, setLoadingClienteNovo] = useState(false);

  const [recalcularValor, setRecalcularValor] = useState('N');
  const [justificativa, setJustificativa] = useState('');

  const [confirmacaoAberta, setConfirmacaoAberta] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const resetFluxoAlteracao = useCallback(() => {
    setPodeAlterar(false);
    setCodigoNovoCliente('');
    setClienteNovo(null);
    setRecalcularValor('N');
    setJustificativa('');
  }, []);

  const verificarPagamento = useCallback((idProcesso) => {
    setLoadingPagamento(true);
    findFichaFinanceiraAnalitica(idProcesso, 0, 1, ['dataLancamento,DESC']).then((response) => {
      const possuiPagamento = (response.data?.totalElements ?? 0) > 0;
      setBloqueadoPorPagamento(possuiPagamento);
      setPodeAlterar(!possuiPagamento);
    }).catch((exception) => {
      toast.error(getExceptionMessage(exception) || MENSAGEM_ERRO_VERIFICAR_PAGAMENTO);
      setBloqueadoPorPagamento(false);
      setPodeAlterar(false);
    }).finally(() => {
      setLoadingPagamento(false);
    });
  }, []);

  const buscarProcesso = useCallback((numero) => {
    setLoading(true);
    return findClienteByNumProcesso(numero).then((response) => {
      setClienteAtual(response.data);
      resetFluxoAlteracao();
      verificarPagamento(numero);
    }).catch((exception) => {
      setClienteAtual(null);
      toast.error(getExceptionMessage(exception) || MENSAGEM_ERRO_BUSCA_PROCESSO);
    }).finally(() => {
      setLoading(false);
    });
  }, [resetFluxoAlteracao, verificarPagamento]);

  const handleSubmitSearchForm = useCallback((e) => {
    e.preventDefault();
    buscarProcesso(numProcesso);
  }, [buscarProcesso, numProcesso]);

  const handleChangeNumProcesso = useCallback((e) => {
    const { value } = e.target;
    setNumProcesso(value);
  }, []);

  const handleConsultarNovoCliente = useCallback(() => {
    setLoadingClienteNovo(true);
    findSimpleCliente(codigoNovoCliente.trim(), STATUS_CLIENTE_ATIVO).then((response) => {
      setClienteNovo(response.data);
    }).catch((exception) => {
      setClienteNovo(null);
      toast.warn(getExceptionMessage(exception) || MENSAGEM_ERRO_BUSCA_CLIENTE_NOVO);
    }).finally(() => {
      setLoadingClienteNovo(false);
    });
  }, [codigoNovoCliente]);

  const handleChangeCodigoNovoCliente = useCallback((e) => {
    const { value } = e.target;
    setCodigoNovoCliente(value);
    setClienteNovo(null);
  }, []);

  const handleChangeRecalcularValor = useCallback((e) => {
    setRecalcularValor(e.target.value);
  }, []);

  const handleChangeJustificativa = useCallback((e) => {
    setJustificativa(e.target.value);
  }, []);

  const abrirConfirmacao = useCallback(() => {
    setConfirmacaoAberta(true);
  }, []);

  const fecharConfirmacao = useCallback(() => {
    setConfirmacaoAberta(false);
  }, []);

  const confirmarAlteracao = useCallback(() => {
    const codigoAnterior = clienteAtual?.idCliente;
    const idProcesso = numProcesso;
    const codigoNovo = codigoNovoCliente.trim();
    const motivo = justificativa.trim();

    setLoadingSubmit(true);
    updateClienteDoProcesso(numProcesso, codigoNovo, recalcularValor, motivo)
      .then(() => {
        toast.success(MENSAGEM_SUCESSO_ALTERACAO);
        const texto = `Alterado o código do cliente do processo de ${codigoAnterior} para ${codigoNovo}, motivo: ${motivo}`;
        inserirNovoHistorico(idProcesso, tiposHistoricos.COMENTARIO_AUTOMATIO.key, texto).catch(() => {
          toast.warn(MENSAGEM_ERRO_HISTORICO_AUTOMATICO);
        });
        return buscarProcesso(numProcesso);
      })
      .catch((exception) => {
        toast.error(getExceptionMessage(exception) || MENSAGEM_ERRO_ALTERACAO);
      })
      .finally(() => {
        setLoadingSubmit(false);
        setConfirmacaoAberta(false);
      });
  }, [clienteAtual, justificativa, numProcesso, codigoNovoCliente, recalcularValor, buscarProcesso]);

  const justificativaValida = possuiMinimoPalavras(justificativa, MINIMO_PALAVRAS_JUSTIFICATIVA);
  const habilitarBotaoAlterar = Boolean(clienteNovo) && Boolean(recalcularValor) && justificativaValida;

  return (
    <WrapperSubTitleForm title={TITULO_PAGINA} className={style.pageRoot}>
      <LoadingUI show={loading || loadingPagamento || loadingClienteNovo || loadingSubmit} />
      <Typography>{SUBTITULO_PAGINA}</Typography>

      <form onSubmit={handleSubmitSearchForm}>
        <Grid24 container isFormContainer spacing="1" className={style.formSection}>
          <Grid24 xs={24} sm={6}>
            <NumberInput
              isForm
              fullWidth
              numberType="integer"
              name="numProcesso"
              label={LABEL_NUMERO_PROCESSO}
              value={numProcesso}
              onChange={handleChangeNumProcesso}
              maxLength={MAX_LENGTH_NUM_PROCESSO}
              acceptEmptyValue
            />
          </Grid24>
          <Grid24 xs={24} sm={2}>
            <SearchButton
              className={style.searchButtonCircular}
              type="submit"
              disabled={numProcesso.trim() === ''}
            >
              <SearchIcon />
            </SearchButton>
          </Grid24>
        </Grid24>
      </form>

      {clienteAtual && (
        <Grid24 container isFormContainer spacing="1" className={style.formSection}>
          <Grid24 xs={24} sm={4}>
            <InputField
              disabled
              isForm
              fullWidth
              label={LABEL_CODIGO_CLIENTE}
              value={clienteAtual.idCliente}
            />
          </Grid24>
          <Grid24 xs={24} sm={10}>
            <InputField
              disabled
              isForm
              fullWidth
              label={LABEL_RAZAO_SOCIAL_NOME}
              value={clienteAtual.nomeCliente}
            />
          </Grid24>
        </Grid24>
      )}

      {clienteAtual && podeAlterar && (
        <>
          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={6}>
              <NumberInput
                isForm
                fullWidth
                numberType="integer"
                name="codigoNovoCliente"
                label={LABEL_NOVO_CODIGO_CLIENTE}
                value={codigoNovoCliente}
                onChange={handleChangeCodigoNovoCliente}
                acceptEmptyValue
              />
            </Grid24>
            <Grid24 xs={24} sm={3}>
              <ButtonUI
                className={style.searchButtonText}
                disabled={codigoNovoCliente.trim() === ''}
                showLoading={loadingClienteNovo}
                onClick={handleConsultarNovoCliente}
              >
                {LABEL_CONSULTAR}
              </ButtonUI>
            </Grid24>
          </Grid24>

          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={10}>
              <InputField
                disabled
                isForm
                fullWidth
                label={LABEL_RAZAO_SOCIAL_NOME}
                value={clienteNovo?.nome ?? ''}
              />
            </Grid24>
          </Grid24>

          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={6}>
              <SelectorField
                isForm
                fullWidth
                label={LABEL_RECALCULAR_PROCESSO}
                name="recalcularValor"
                value={recalcularValor}
                items={RECALCULAR_VALOR_OPTIONS}
                onChange={handleChangeRecalcularValor}
              />
            </Grid24>
          </Grid24>

          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={14}>
              <TextareaField
                isForm
                fullWidth
                label={LABEL_JUSTIFICATIVA}
                name="justificativa"
                value={justificativa}
                onChange={handleChangeJustificativa}
                showCounter
                maxCounter={MAX_COUNTER_JUSTIFICATIVA}
              />
            </Grid24>
          </Grid24>

          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={4}>
              <ButtonUI
                color="success"
                onClick={abrirConfirmacao}
                disabled={!habilitarBotaoAlterar}
              >
                {LABEL_ALTERAR}
              </ButtonUI>
            </Grid24>
          </Grid24>
        </>
      )}

      <OptionDialogNew
        open={bloqueadoPorPagamento}
        onClickConfirm={() => setBloqueadoPorPagamento(false)}
        confirmLabel="OK"
      >
        <p>{MENSAGEM_BLOQUEIO_PAGAMENTO}</p>
      </OptionDialogNew>

      <OptionDialogNew
        open={confirmacaoAberta}
        onClickCancel={fecharConfirmacao}
        onClickConfirm={confirmarAlteracao}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
      >
        <p>{MENSAGEM_CONFIRMACAO_ALTERACAO}</p>
      </OptionDialogNew>
    </WrapperSubTitleForm>
  );
}
